import validate from "/usr/src/app/content/n3-packages-cf355189-79cb-4aa6-ac18-d6ec89530086/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-cf355189-79cb-4aa6-ac18-d6ec89530086/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}